module.exports = __webpack_public_path__ + "static/media/BDScurriculum.dc84d726.pdf";